import { SvgIcon } from '@mui/material';

export default function AccountIcon({ ...props }) {
  return (
    <SvgIcon {...props}>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M20.34 16.67C19.25 15.52 17.98 14.62 16.57 13.99C16.32 13.88 16.07 13.79 15.81 13.7C17.4 12.51 18.43 10.63 18.43 8.5C18.43 4.92 15.51 2 11.93 2C8.35 2 5.43 4.92 5.43 8.5C5.43 10.63 6.46 12.52 8.05 13.7C7.8 13.79 7.54 13.88 7.3 13.99C5.89 14.62 4.62 15.52 3.53 16.67C2.45 17.82 1.6 19.15 1 20.63L2.86 21.37C3.36 20.12 4.07 19 4.98 18.04C5.89 17.08 6.94 16.33 8.11 15.81C10.53 14.73 13.33 14.73 15.74 15.81C16.91 16.33 17.97 17.08 18.87 18.04C19.78 19 20.49 20.12 20.99 21.37L22.85 20.63C22.26 19.15 21.41 17.82 20.32 16.67H20.34ZM11.94 3.99C14.42 3.99 16.44 6.01 16.44 8.49C16.44 10.97 14.42 12.99 11.94 12.99C9.46 12.99 7.44 10.97 7.44 8.49C7.44 6.01 9.46 3.99 11.94 3.99Z'
          fill='currentColor'
        />
      </svg>
    </SvgIcon>
  );
}
